import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithReauth } from '@/services';
import { API_BUSINESS_URL } from '@/utils';

export interface AssignUserRolesPayload {
  userId: string;
  roleIds: string[];
}

const userRolesService = createApi({
  reducerPath: 'businessUserRolesService',
  baseQuery: createBaseQueryWithReauth(API_BUSINESS_URL),
  tagTypes: ['Users'],
  endpoints: (builder) => ({
    assignUserRoles: builder.mutation<void, AssignUserRolesPayload>({
      query: (body) => ({
        url: '/user-roles',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Users'],
    }),
  }),
});

export default userRolesService;
export const { useAssignUserRolesMutation } = userRolesService;
